<div class="toolbar" style="margin: 0.5rem;">
  <button
    style="margin-right: 0.5rem;"
    nz-button
    nzType="dashed"
    (click)="exportPdf()">
    Xuất PDF
  </button>

  <button
    nz-button
    nzType="dashed"
    onclick="window.print()">
    In phiếu
  </button>
</div>

<div id="print-div" class="print-wrapper">
  <img
*ngIf="lstConfigPrintOrder.backgroundLogo"
class="logo-background"
[src]="urlBackground"
/>
<div class="print-header">
  <table border="0" width="100%" style="margin-bottom: 2rem">
    <tr>
      <td class="logo">
        <img
        *ngIf="lstConfigPrintOrder.logo"
        style="height: 120px; margin: auto; display: block"
        [src]="urlHeader"
        />
      </td>
      <td class="content-header">
        <h1 style="text-align: center">Phòng xét nghiệm Invivolab</h1>
        <div style="text-align: center">
          <p>Địa chỉ: 257B1 Giải Phóng, Phương Mai, Đống Đa, TP Hà Nội</p>
        </div>
        <div class="row-info flex-item">
          <div class="col-5">
          Email:<a href="info@invivolab.vn" class="link-info">
            info@invivolab.vn</a
            >
          </div>
          <div class="hoz-divider col-2">|</div>
          <div class="col-5">
            Website:<a href="invivolab.vn" class="link-info"> invivolab.vn</a>
          </div>
        </div>
      </td>
    </tr>
  </table>
  <div class="flex-item" style="font-family: serif; display: flex">
    <h2 class="col-9" style="text-align: center; text-transform: uppercase; flex-grow: 1">
      Kết quả sàng lọc trước sinh
    </h2>
    <div class="col-3">
      <ngx-barcode
      [bc-font-size]="9"
      [bc-margin]="1"
      [bc-width]="2"
      [bc-height]="45"
      [bc-font]=""
      [bc-value]="orderCode"
      bc-element-type="svg"
      [bc-display-value]="true"
      [bc-margin-top]="1"
      [bc-margin-bottom]="1"
      [bc-margin-left]="1"
      [bc-margin-right]="1"
      ></ngx-barcode>
    </div>
  </div>
    <table style="border-collapse: collapse;" border="0" width="80%" class="info">
      <tr>
        <td>Họ và tên:</td>
        <td style="text-transform: uppercase; font-weight: bold">
          {{ orderItem.patient.name }}
        </td>
        <td>Năm sinh: {{ orderItem.patient.dob | dateFormat: "yyyy" }}</td>
        <td>Giới tính: {{ orderItem.patient.sex === 0 ? "Nữ" : "Nam" }}</td>
      </tr>
      <tr>
        <td>Địa chỉ:</td>
        <td colspan="2">{{ orderItem.patient.address }}</td>
        <td>Số điện thoại: {{ orderItem.patient.phone }}</td>
        <td></td>
      </tr>
      <tr>
        <td *ngIf="lstConfigPrintOrder.doctor">Bác sỹ chỉ định:</td>
        <td *ngIf="lstConfigPrintOrder.doctor" colspan="2">
          {{ orderItem.orderDoctor }}
        </td>
        <td>Đơn vị:</td>
        <td></td>
      </tr>
      <tr>
        <td>Chẩn đoán:</td>
        <td colspan="2">{{ orderItem.chanDoan }}</td>
        <td>Ghi chú: {{ orderItem.note }}</td>
        <td></td>
      </tr>
    </table>
    <table border="0" width="100%" class="info">
      <tr>
        <td>
          TG lấy mẫu:
          {{
          resultValues.dateTaken == null ? "" : resultValues.dateTaken | date: "hh:mm"
          }}
        </td>
        <td>Loại mẫu:</td>
        <td>
          Ngày lấy mẫu:
          {{
            resultValues.dateTaken == null ? "" : resultValues.dateTaken | date: "dd/MM/yyyy"
          }}
        </td>
      </tr>
      <tr>
        <td>
          TG nhận mẫu:
          {{
            resultValues.dateReceived == null ? "" : resultValues.dateReceived | date: "hh:mm"
          }}
        </td>
        <td>Tình trạng mẫu: Đạt</td>
        <td>
          Ngày nhận mẫu:
          {{
            resultValues.dateReceived == null ? "" : resultValues.dateReceived
            | date: "dd/MM/yyyy"
          }}
        </td>
      </tr>
    </table>
    <table style="border-collapse: collapse;" border="0" width="100%" class="info">
      <tr>
        <td>Tuổi thai theo siêu âm: <span style="margin: 0px 5px">tuần {{resultValues.order.gestationalWeek}}</span><span style="margin: 0px 5px">ngày {{resultValues.order.gestationalDay}}</span></td>
      </tr>  
    </table>
    <br />
    
    <div style="margin-bottom: 20px">
      <div class="header-table" style="font-size: 20px; margin-bottom: 20px; text-transform: uppercase;">I. Kết quả xét nghiệm: Double Test</div>
      <div class="header-table">1.1. Kết quả định lượng PAPP-A và Free Beta HCG</div>
      <table style="border-collapse: collapse;" width="100%" class="table-result">
        <thead>
          <tr>
            <th width="45%"></th>
            <th width="20%">Đơn vị</th>
            <th width="20%">Nồng độ</th>
            <th width="15%">MoM</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of dataTable1"> 
            <tr>
              <td>{{data.orderTypeName}}</td>
              <td class="text-center">{{data.unitName}}</td>
              <td class="text-center">{{data.valueStr}}</td>
              <td class="text-center">{{data.valueMoM}}</td>
            </tr>
          </ng-container>
        </tbody> 
      </table>

      <div class="header-table">1.2. Phân tích nguy cơ</div>
      <table style="border-collapse: collapse;" width="100%" class="table-result">
        <thead>
          <tr>
            <th width="45%"></th>
            <th width="20%">Nguy cơ</th>
            <th width="20%">Ngưỡng phân biệt</th>
            <th width="15%">Kết luận</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of dataTable2">
            <tr>
              <td>{{data.orderTypeName}}</td>
              <td class="text-center">{{data.valueStr}}</td>
              <td class="text-center">{{data.normalResult}}</td>
              <td class="text-center">{{data.note}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    
    <div>
      <div class="header-table" style="font-size: 20px; margin-bottom: 20px; text-transform: uppercase;">II. Kết luận chung</div>
    </div>
    
    <div class="date-sign">
      Hà Nội, ngày {{resultValues.dateTaken == null ? "" : resultValues.dateTaken | date: "dd"}} tháng {{resultValues.dateTaken == null ? "" : resultValues.dateTaken | date: "MM"}} năm {{resultValues.dateTaken == null ? "" : resultValues.dateTaken | date: "yyyy"}}
    </div>
    <div class="sign flex-item">
      <div *ngIf="lstConfigPrintOrder.conductor">Người thực hiện</div>
      <div *ngIf="lstConfigPrintOrder.responsible">Phụ trách chuyên môn</div>
      <div *ngIf="lstConfigPrintOrder.professionalCouncil">
        Hội đồng chuyên môn
      </div>
    </div>
    <div class="note">
      <p>
        *Lưu ý: Kết quả sàng lọc chỉ ra nguy cơ xác suất mắc bệnh của thai, phụ thuộc vào độ chính xác của các thông tin tại thời điểm xét nghiệm, không có ý nghĩa khẳng định thai bị bệnh
      </p>
    </div>
    <!-- <div class="content-footer">
      <div>
        Thời gian trả KQ:
        {{
          data.resultValues.data[0]?.value.testedDate | date: "hh:mm dd/MM/yyyy"
        }}
      </div>
      <div>
        <p>
          *: Xét nghiệm đã được công nhận theo ISO 15189:2012,
          <br />**: XN thực hiện theo PXN chuyển gửi, <br />Các giá trị in đậm
          là giá trị nằm ngoài khoảng tham chiếu, <br />Các kết quả XN chỉ có
          giá trị đối với mẫu đã nhận.
        </p>
      </div>
    </div> -->
  </div>
</div>
